import { ColumnDef } from '@tanstack/react-table';

import { CSV_REPORT_TYPES } from '@/api/rest/resources/types/reports';
import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { PlotRow } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plots/components/Cells';
import { CsvExportButton } from '@/pages/shared/reports/components/CsvExportButton';

import { useAGCarbonCells, useBGCarbonCells, useDefaultCustomCells } from '../plots/hooks/useGetCustomCells';
import { LandPageLayout } from './components/LandPageLayout';

export const LandCarbonPage = () => {
  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_asset_carbon,
    WidgetType.t_page,
  );

  const customPlotListColumns: ColumnDef<PlotRow>[] = [
    ...useAGCarbonCells(),
    ...useBGCarbonCells(),
    ...useDefaultCustomCells(),
  ];

  return (
    <LandPageLayout
      navBarProps={{
        children: <CsvExportButton reportType={CSV_REPORT_TYPES.CARBON_CSV} className='w-fit font-normal' />,
      }}
      plotListProps={{
        customColumns: customPlotListColumns,
      }}
    >
      <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
    </LandPageLayout>
  );
};
